import moment from "moment";
import { Div, Span } from "@tblabs/truffle";
import { ChatEntry, ContentType, MessageChatEntry, PictureChatEntry } from "../Models/ChatEntry";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { PicturesGallery } from "./PicturesGallery";


export class MessageBox extends Div
{
    constructor(type: "sent" | "received", entry: ChatEntry)
    {
        super("message " + type);

        const time = moment(entry.Time).format(" • ddd • DD.MM.YYYY • HH:mm:ss");

        this.Append(
            new Div("message-user").Append(new Span(entry.AuthorId).Bold(), time),
            new Div("message-content").Append(this.DetermineMessageContent(entry)),
        );
    }

    private DetermineMessageContent(entry: ChatEntry): appendable
    {
        switch (entry.ContentType)
        {
            case ContentType.Message:
                const messageEntry = entry as MessageChatEntry;
                return new Span(messageEntry.Content);
            case ContentType.Pictures:
                const picturesEntry = entry as PictureChatEntry;
                return new PicturesGallery(picturesEntry.Pictures);
            default:
                return entry.Content;
        }
    }
}
